// @ts-strict-ignore
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter, forwardRef,
  HostBinding, Inject,
  Input,
  NgZone, OnDestroy, OnInit,
  Output, QueryList,
  ViewChildren, ViewContainerRef
} from '@angular/core';
import {
  LMBusyIndicatorService,
  LMComponentInfoService,
  LMContextService,
  LMFormatUtilService,
  LMLoggerService, LMRoamingUIProfileService
} from '@app/services';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMApplicationMenuService } from '../services/lm-application-menu.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMGlobalPersonalizationService } from '../../../states/services/lm-global-personalization.service';
import { LMApplicationMenuSubMenuService } from '@components/applicationmenu/submenu/lm-application-menu-submenu.service';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import {
  AppConstants,
  LMBrowserUtilService,
  LMContextUtilService,
  LMGlobalUtilService,
  LMUniqueIdService
} from '@app/utils';
import { cloneDeep } from 'lodash-es';
import {
  LMActionFormDialogService,
  LMApplicationMenuAsOfDateDialogService,
  LMApplicationMenuSearchService,
  LMApplicationMenuUserContextDialogService,
  LMCreateReportDialogService,
  LMFormRequestService,
  LMLoginService,
  LMReportPersonalizationDialogService, LMReportsCatalogService
} from '@app/components';
import { SohoMessageService, SohoModalDialogService, SohoToastService } from "ids-enterprise-ng";
import { Router } from "@angular/router";
import { LMThemeService } from "@banner/lm-theme.service";
import { LMApplicationMenuBaseDirective } from "@components/applicationmenu/lm-application-menu-base.directive";
import { LMWebAppService } from '@services/lm-webapp.service';

@Component({
  selector: 'lm-application-menu-submenu',
  templateUrl: 'lm-application-menu-submenu.component.html',
  styleUrls: [ 'lm-application-menu-submenu.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LMRoamingUIProfileService]
  })
export class LMApplicationMenuSubmenuComponent extends LMApplicationMenuBaseDirective implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  @HostBinding('style.display') display = 'block';

  @Input() inSearchResultsMenu = false;
  @Input() menuItemSpecs: Array<LMMenuItemSpec>;
  @Output() menuStateRestored: EventEmitter<any> = new EventEmitter<any>();
  @Output() menuLoaded: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren('accordionHeader', { read: ViewContainerRef }) accordionHeaders: QueryList<ViewContainerRef>;

  constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmWebAppService: LMWebAppService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmThemeService: LMThemeService,
    protected lmCreateReportDialogService: LMCreateReportDialogService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    protected lmCommonReportsService: LMReportsCatalogService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected ngZone: NgZone,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected routeComponent: LMRouteComponentService
  ) {
    super(
      sohoModalDialogService,
      sohoToastService,
      lmAsOfDateService,
      lmContextService,
      lmApplicationMenuService,
      lmFormRequestService,
      lmFormatUtilService,
      lmSpecService,
      lmWebAppService,
      lmErrorUtilService,
      lmLoggerService,
      lmUrlUtilService,
      lmGlobalUtilService,
      lmLoginService,
      lmContextUtilService,
      lmReportPersonalizationDialogService,
      lmGlobalPersonalizationService,
      lmUniqueIdService,
      sohoMessageService,
      lmApplicationMenuSearchService,
      lmBusyIndicatorService,
      lmUserContextService,
      lmActionFormDialogService,
      changeDetectorRef,
      router,
      lmRoamingUIProfileService,
      lmThemeService,
      lmCreateReportDialogService,
      lmBrowserUtilService,
      lmCommonReportsService,
      lmComponentInfoService,
      ngZone,
      lmApplicationMenuSubMenuService,
      routeComponent
    );
  }

  ngOnInit() {
    this.clearSubMenus(this.menuItemSpecs);
  }

  ngAfterViewInit() {
    this.updateRequired = true;
    this.subscribeToMenuItemClick();
  }

  ngAfterViewChecked() {
    if (this.updateRequired && this.lmApplicationMenuService.lastOpenedMenuId && this.accordionHeaders.length > 0) {
      const lastMenu = this.accordionHeaders.filter((header => header.element.nativeElement.id === this.lmApplicationMenuService.lastOpenedMenuId));
      if (lastMenu.length > 0) {
        this.lmApplicationMenuService.setLastOpenedMenu(lastMenu[ 0 ].element.nativeElement);
        this.updateRequired = false;
      }
    }
  }

  public trackById(index: number, menuItem: any): string {
    return menuItem.id;
  }

  ngOnDestroy() {
    this._destroy$.next(true);
    this._destroy$.complete();
    // this.pausableSubscription.unsubscribe();
    this._pause$.complete();
    this._menuItemClicked$.complete();
  }

  public loadSubMenu(event: MouseEvent, menuItem: LMMenuItemSpec): void {
    if (menuItem.expanded) {
      menuItem.expanded = false;
      return;
    }

    const menuItemSpecMenu = [];
    const self = this;

    if (this.inSearchResultsMenu) {
      const allSearchLevelsResponse = cloneDeep(this.lmWebAppService.getAllCachedWebApps());
      allSearchLevelsResponse.forEach((webApp) => {
          // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
        webApp.menuSpecs.forEach(function callback(menuItemSpec) {
          if (menuItemSpec.menuIndex === menuItem.menuIndex
              && menuItem.id === menuItemSpec.id) {
            menuItemSpecMenu.push(menuItemSpec.menu);
            self.clearSubMenus(menuItemSpec.menu);
          }

          if (menuItemSpec.menu && menuItemSpec.menu.length > 0) {
            menuItemSpec.menu.forEach(callback);
          }
        });
      });
      menuItem.menu = menuItemSpecMenu[0];
    } else {
      const currentWebAppMenuSpec = this.lmWebAppService.getAllCachedWebApps().find(v => v.webAppName === this.lmContextService.getCurrentWebAppSpec().webAppName);
      const allLevelsResponse = cloneDeep(currentWebAppMenuSpec);
        // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      allLevelsResponse.menuSpecs.forEach(function callback(menuItemSpec) {
        if (menuItemSpec.menuIndex === menuItem.menuIndex) {
          menuItemSpecMenu.push(menuItemSpec.menu);
          self.clearSubMenus(menuItemSpec.menu);
        }

        if (menuItemSpec.menu && menuItemSpec.menu.length > 0) {
          menuItemSpec.menu.forEach(callback);
        }
      });

      menuItem.menu = menuItemSpecMenu[0];
    }

    menuItem.expanded = true;

    this.lmApplicationMenuService.saveExpandedMenus(menuItem);
    this.onMenuLoaded(event);
  }

  public onMenuLoaded(event): void {
    this.menuLoaded.emit(event);
  }

  /**
   * Set href url when a right click is executed
   * @param event
   * @param menuItem
   */
  public onMenuItemRightClicked(event: MouseEvent, menuItem: LMMenuItemSpec) {
    if (menuItem && menuItem.link) {
      (event.currentTarget as HTMLElement).setAttribute('href', menuItem.link);
    }
  }

  public menuIdV1(menuItem: LMMenuItemSpec) {
    return this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1 ? menuItem.id : null;
  }

  public menuIdV2(menuItem: LMMenuItemSpec) {
    return this.lmContextService.testVersion() >= AppConstants.TESTVERSION_V2 ? menuItem.id + '_menuitem' : null;
  }

  /**
   * Used for data-automation-id, this function will convert underscores _ and
   * _prd_ to a dash -
   * @param menuItem
   */
  public dataAutomationId(menuItem: LMBannerSearchResult|LMMenuItemSpec) {
    // const automationId = menuItem.id.replace(/(_prd_)|(_)/g, '-');
    if (this.inSearchResultsMenu) {
      return `lm-${menuItem.automationId}-searchresult`;
    }
    return `lm-${menuItem.automationId}-menuitem`;
  }

  /**
   * Clear all menu arrays so the template does not render every level
   * @param menuSpec
   */
  private clearSubMenus(menuSpec: Array<LMMenuItemSpec>) {
    if (Array.isArray(menuSpec)) {
      menuSpec.map((menuSpecItem: LMMenuItemSpec) => {
        if (menuSpecItem.menu && !menuSpecItem.expanded) {
          menuSpecItem.menu = [];
        }

        return menuSpecItem;
      });
    }
  }
}
